import { render, staticRenderFns } from "./CatalogoPreventivo.vue?vue&type=template&id=8b23725a&scoped=true&"
import script from "./CatalogoPreventivo.vue?vue&type=script&lang=js&"
export * from "./CatalogoPreventivo.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoPreventivo.vue?vue&type=style&index=0&id=8b23725a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b23725a",
  null
  
)

export default component.exports